import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { NavLink as NavLinkRRD } from "react-router-dom";
import { NavLink } from "reactstrap";
import { SearchRoutes, userRoutes } from "../Routes";
import collapsedIcon from "../assets/images/brand/logo-icon.png";
import { ProductContext } from "../store";
import Skeleton from "react-loading-skeleton";

function Sidebar() {
  const location = useLocation(); // Get the current location
  const [isCollapsed, setIsCollapsed] = useState(false);

	const  {
		addPageOpen,
		userLoader,
		websiteData,
		currentWebsiteId,
		userWebsitePlan,
		productTypes
	} = useContext(ProductContext);
	const [websitePlatform, setWebsitePlatform] = useState("");
	useEffect(() => {
		if(userLoader || !userWebsitePlan || !Array.isArray(userWebsitePlan) || userWebsitePlan.length === 0){
			return
		}
		if(currentWebsiteId){
			setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType)
		}
	}, [currentWebsiteId, userLoader, userWebsitePlan])

	// Collapse the sidebar based on the current path
	useEffect(() => {
		if (location.pathname.startsWith("/search") || location.pathname.startsWith("/upsell") || location.pathname.startsWith("/aiassistant") || location.pathname.startsWith("/cmsassistant") || location.pathname.startsWith("/aivisibility")) {
			setIsCollapsed(true);
		} else {
			setIsCollapsed(false);
		}
	}, [location.pathname]); // Run the effect whenever the path changes

	return (
		<div className={`applicationsSidebar ${isCollapsed ? "collapsed" : ""}`}>
			<aside className="applicationRootSidebar">
				<div className="applicationSidebarScroll">
					<div className="scrollIndicatorContent">
						<header className="sidebarHeader">
							{isCollapsed ? (
								<img
									src={collapsedIcon}
									alt="Collapsed Logo"
									className="img-fluid"
								/>
							) : (
								<img
									src={require("./../assets/images/brand/cb-logo-color.png")}
									alt="ConversionBox"
									className="img-fluid"
								/>
							)}
						</header>
						<div className="navigationWrapper">
							{websitePlatform === "" && !productTypes ?
								<>
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
									<Skeleton height={10} />
								</>
							:
								<>
									<nav>
										<ul className="mainNavigationList">
											{userRoutes.map((userRoute, index) => {
												return (
													<React.Fragment key={index}>
														{userRoute.type === "mainMenu" && (
															<>
																{(index === 1 && !isCollapsed) &&
																	<li className="mt-1">
																		<span style={{color: "#fff"}}>Products</span>
																	</li>
																}
																{((!userRoute.accessPlans || ( userRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => userRoute.accessPlans.includes(plan.planId)) ) ) && ( !userRoute.availablePlatforms || ( userRoute.availablePlatforms && userRoute.availablePlatforms.includes(websitePlatform) ) ) && ( !userRoute.productType || ( userRoute.productType && productTypes.includes(userRoute.productType) ) ) ) && (
																	<li>
																		<NavLink
																			to={userRoute.layout + userRoute.path}
																			tag={NavLinkRRD}
																			className={`navItem ${userRoute.itemClass ? userRoute.itemClass : ""
																				}`}
																			activeClassName="active"
																		>
																			{userRoute.menuSvg ? (
																				<div
																					dangerouslySetInnerHTML={{
																						__html: userRoute.menuSvg,
																					}}
																				/>
																			) : null}
																			<span className="rootNavText">
																				{userRoute.name}
																			</span>
																		</NavLink>
																	</li>
																)}
															</>
														)}
													</React.Fragment>
												);
											})}
										</ul>
											{/* <ul className="mainNavigationList collapsedList">
												{SearchRoutes.map((searchRoute, index) => {
												return (
													<React.Fragment key={index}>
														{searchRoute.type === "searchMenu" && (
														<NavLink
															to={searchRoute.layout + searchRoute.path}
															tag={NavLinkRRD}
															className={`searchItem ${
																searchRoute.itemClass ? searchRoute.itemClass : ""
															}`}
															activeClassName="active"
														>
															{searchRoute.menuSvg ? (
																<div
																dangerouslySetInnerHTML={{
																	__html: searchRoute.menuSvg,
																}}
																/>
															) : null}
															<span className="rootNavText">
																{searchRoute.name}
															</span>
														</NavLink>
														)}
													</React.Fragment>
												);
												})}
											</ul> */}
                           </nav>
									<nav className="rootSidebarBottom">
										<ul className="innerRootSidebarBottom">
											{userRoutes.map((userRoute, index) => {
												return (
												<React.Fragment key={index}>
													{userRoute.type === "bottomMenu" && ((!userRoute.accessPlans || ( userRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => userRoute.accessPlans.includes(plan.planId)) ) ) && ( !userRoute.availablePlatforms || ( userRoute.availablePlatforms && userRoute.availablePlatforms.includes(websitePlatform) ) ) && ( !userRoute.productType || ( userRoute.productType && productTypes && productTypes.includes(userRoute.productType) ) ) ) && (
														<li>
															<NavLink
															to={userRoute.layout + userRoute.path}
															tag={NavLinkRRD}
															className={`navItem ${
																userRoute.itemClass ? userRoute.itemClass : ""
															}`}
															activeClassName="active"
															>
															{userRoute.menuSvg ? (
																<div
																	dangerouslySetInnerHTML={{
																	__html: userRoute.menuSvg,
																	}}
																/>
															) : null}
															<span className="rootNavText">
																{userRoute.name}
															</span>
															</NavLink>
														</li>
													)}
												</React.Fragment>
												);
											})}
										</ul>
									</nav>
                			</>
              			}
            		</div>
          		</div>
        		</div>
      	</aside>
    	</div>
  	);
}

export default Sidebar;
